export default __webpack_public_path__ + "static/media/sample.d3bc34dc.mp4";